import React from "react";
import { Link, useHistory } from "react-router-dom";
import store from "../../reducers/store";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGear,
  faListUl,
} from "@fortawesome/free-solid-svg-icons";
import { css } from "aphrodite";
import styles from "./PatientDashboard/style";
import { Col, OverlayTrigger, Tooltip, Card } from "react-bootstrap";

export default function ActivityCard({ recentActivities, batteryData, recentMotionMonitoring, recentHrMonitoring, recentFallDetectionMonitoring, maxDate, cardData, isPatient, appModules, recentSafeLocationAlertTime }) {
  const history = useHistory();

  const handleClick = (item) => {
    store.dispatch({ type: "SET_CURRENT_MEDICATIONS_DATA", payload: { currentMedications: item } });
    store.dispatch({ type: "SET_SAFE_LOCATION_ALERTS_DATA", payload: { safeLocationAlerts: item } });
  }

  const goTo = (e, path) => {
    if (!path) return;
    e.preventDefault();
    e.stopPropagation();
    history.push(path);
  };

  // 🧠 Hide card if module is missing
  const isModuleAvailable = () => {
    if (!appModules) return false;

    const key = cardData.key;
    const moduleMap = {
      heartRate: "WM",
      heartRateMonitoring: "HRM",
      motionMonitoring: "SD",
      callForHelp: "CALRT",
      fallDetection: "FD",
      safeLocation: "GPS",
      stepsCount: "WM",
      caloriesBurned: "WM",
      currentMedication: "MEDC"
    };

    const moduleKey = moduleMap[key];
    if (!moduleKey) return true;

    const isActive = appModules.active?.[moduleKey];
    const isInactive = appModules.inactive?.[moduleKey];

    return !!(isActive || isInactive);
  };

  if (!isModuleAvailable()) {
    return null; // ❌ Hide card completely
  }


const callForHelp = cardData.key === "callForHelp";
  const hasSafeLocationSubscription = appModules?.active?.GPS?.includes(
    "GEO_LOCATION_TRACKING"
  );
  const canShowCardTooltip = !!cardData.tooltip?.length && (
    cardData.key !== "safeLocation" || hasSafeLocationSubscription
  );
  const canNavigateToCard = !!cardData?.link && (
    cardData.key !== "safeLocation" || hasSafeLocationSubscription
  );
  const canShowSettingsIcon = !!cardData.settingsIcon && (
    (appModules.active?.SD && cardData.key === "motionMonitoring") ||
    (appModules.active?.HRM && cardData.key === "heartRateMonitoring") ||
    (appModules.active?.CALRT && callForHelp) ||
    (appModules.active?.FD && cardData.key === "fallDetection") ||
    (hasSafeLocationSubscription && cardData.key === "safeLocation")
  );
  const canShowListIcon = !!cardData.listLink && (
    (appModules.active?.SD && cardData.key === "motionMonitoring") ||
    (appModules.active?.HRM && cardData.key === "heartRateMonitoring")
     || (appModules.active?.FD && cardData.key === "fallDetection") 
  );
  const cardIconStyle = cardData.key === "currentMedication"
    ? {
      width: "50px",
      height: "50px",
    }
    : callForHelp
      ? {
        width: "48px",
        height: "48px",
        backgroundColor: "transparent",
        objectFit: "contain",
        // Recolor the legacy black icon to dashboard blue.
        filter: "invert(47%) sepia(77%) saturate(746%) hue-rotate(185deg) brightness(88%) contrast(88%)",
      }
      : {
        width: "60px",
        height: "60px",
        backgroundColor: "transparent",
      };

  return (
    <Col xs={12} sm={6} lg={12} xl={6} className="d-flex align-items-stretch mb-3">
      <OverlayTrigger
        placement="top"
        overlay={canShowCardTooltip ? <Tooltip id="button-tooltip-2">{cardData.tooltip}</Tooltip> : <></>}
      >
        <Link
          to={canNavigateToCard ? cardData.link : "#"}
          //className={css(styles.tooltip)}
          style={{
            flex: 1,
            textDecoration: "none",
          }}
          state={cardData ? cardData : ''}
          onClick={(event) => {
            if (!canNavigateToCard) {
              event.preventDefault();
              return;
            }
            handleClick(cardData);
          }}
          className={!canNavigateToCard ? css(styles.noLink) : ''}
        >
          <Card
            style={{ borderRadius: "15px", minHeight: "100px" }}
          >
            <div
              style={{
                padding: "2px 10px 2px",
                textAlign: "end",
                color: "#000000d6"
              }}
            > 
              {cardData.key !== "currentMedication" && "As of "}
              {cardData.key === "battery" && batteryData !== null ? moment(
                batteryData.eventTimestamp
              ).format("MMM DD hh:mm A") : cardData.key === "motionMonitoring" && recentMotionMonitoring !== null ? moment(
                recentMotionMonitoring.eventTimestamp
              ).format("MMM DD hh:mm A") : cardData.key === "heartRateMonitoring" && recentHrMonitoring !== null ? moment(
                recentHrMonitoring.eventTimestamp
              ).format("MMM DD hh:mm A") : cardData.key === "fallDetection" && recentFallDetectionMonitoring !== null ? moment(
                recentFallDetectionMonitoring.eventTimestamp
              ).format("MMM DD hh:mm A") : cardData.key === "safeLocation" && recentSafeLocationAlertTime ? moment(
                recentSafeLocationAlertTime
              ).format("MMM DD hh:mm A") : cardData.key === "sleep" ? moment(
                maxDate
              ).format("MMM DD hh:mm A") : cardData.key === "currentMedication" ? "" : recentActivities !== null ? moment(
                recentActivities
                  .lastUpdatedAt
              ).format("MMM DD hh:mm A") : moment(
                new Date()
              ).format("MMM DD hh:mm A")}
            </div>

            <Card.Body
              className={css(
                styles.cardBodyStyle
              )}
            >

              <div
                style={{
                  padding: "2px 2px",
                }}
              >
                <img
                  alt={cardData.icon}
                  src={callForHelp ? `/images/diary/${cardData.icon}.png`: `/images/dashboard/${cardData.icon}.png`}
                  style={cardIconStyle}
                />
              </div>

              {!cardData.settingsIcon &&
                <div
                  style={{
                    margin: "10px 0px 0px 10px",
                  }}
                >
                  <h6 className="mb-2">
                    {cardData.title}
                  </h6>
                  {appModules.active?.WM || (appModules?.active?.MEDC?.includes(
                    "MEDICATION_CABINET"
                  ) && cardData.key === "currentMedication") || cardData.key === "battery" ?
                    Object.keys(cardData.data).map((element) => {
                      return (
                        <h6
                          className={cardData.data[element] === null ? css(styles.subLabelStyle2) :
                            css(styles.subLabelStyle)}
                          style={{
                            color: cardData.countColorCodes[element],
                          }}
                        >
                          {cardData.data[element] !== null ?
                            cardData.key === "battery" ? `${cardData.data[element]}%` :
                              cardData.key === "heartRate" ? `${cardData.data[element]} bpm` :
                                cardData.key === "caloriesBurned" ? `${cardData.data[element]} kcal` :
                                  cardData.key === "stepsCount" ? `${cardData.data[element]} steps` :
                                    cardData.data[element] : "Not Available"}
                        </h6>
                      )
                    }) : (
                      <h6
                        style={{
                          color: "red",
                          fontSize: "14px"
                        }}
                      >
                        {"Not included in your subscritpion plan"}
                      </h6>
                    )}
                </div>
              }

              {cardData.settingsIcon &&
                <div
                  style={{
                    margin: "10px 0px 0px 10px",
                  }}
                >
                  <h6 className="mb-2">
                    {cardData.title}
                  </h6>
                  {(appModules.active?.SD && cardData.key === "motionMonitoring") ||
                    (appModules.active?.HRM && cardData.key === "heartRateMonitoring") ||
                    (appModules.active?.CALRT && cardData.key === "callForHelp") ||
                    (appModules.active?.FD && cardData.key === "fallDetection") ||
                    (appModules?.active?.GPS?.includes("GEO_LOCATION_TRACKING") && cardData.key === "safeLocation") ?
                    Object.keys(cardData.data).map((element) => {
                      return (
                        <h6
                          className={cardData.data[element] === null ? css(styles.subLabelStyle2) :
                            css(styles.subLabelStyle)}
                          style={{
                            color: cardData.countColorCodes[element],
                          }}
                        >
                          {cardData.data[element] !== null ?
                            cardData.data[element] : cardData.key === "safeLocation" ? "No Alert" : "Not Available"}
                        </h6>
                      )
                    }) : (
                      <h6
                        style={{
                          color: "red",
                          fontSize: "14px"
                        }}
                      >
                        {"Not included in your subscritpion plan"}
                      </h6>
                    )}
                </div>
              }


              {(canShowListIcon || canShowSettingsIcon) ?
                <div
                  style={{
                    position: "absolute",
                    top: "2px",
                    right: "8px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  {canShowListIcon && (
                    <span
                      role="button"
                      tabIndex={0}
                      title={cardData.listIconTooltip || "Click to view events"}
                      onClick={(e) => goTo(e, cardData.listLink)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") goTo(e, cardData.listLink);
                      }}
                      style={{
                        fontSize: "12px",
                        color: "#939090",
                        cursor: "pointer",
                      }}
                      aria-label={cardData.listIconTooltip || "View events list"}
                    >
                      <FontAwesomeIcon icon={faListUl} size="lg" />
                    </span>
                  )}
                  {canShowSettingsIcon && (
                    <span
                      role="button"
                      tabIndex={0}
                      title={cardData.settingsIconTooltip}
                      onClick={(e) => goTo(e, cardData.settingsLink)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") goTo(e, cardData.settingsLink);
                      }}
                      style={{
                        fontSize: "12px",
                        color: "#939090",
                        cursor: "pointer",
                      }}
                      aria-label={cardData.settingsIconTooltip || "Open settings"}
                    >
                      <FontAwesomeIcon icon={faGear} size="lg" />
                    </span>
                  )}
                </div>
                : <div></div>
              }
            </Card.Body>
          </Card>
        </Link>
      </OverlayTrigger>
    </Col>
  );
}
